import { render, staticRenderFns } from "./PaymentTransactionsCollectedNewForm.vue?vue&type=template&id=42e2288a"
import script from "./PaymentTransactionsCollectedNewForm.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionsCollectedNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports